module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-1-7c1a9c4b.jpg";